import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/opt/build/repo/www/src/components/mdx/index.tsx";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h2>{`📦 Components`}</h2>
    <ul>
      <li parentName="ul">{`A rethinking of Modals for all platforms is in the works, with an API review coming shortly. (Lucas S.)`}</li>
    </ul>
    <h2>{`🍭 Design`}</h2>
    <ul>
      <li parentName="ul">{`Email reviews are continuing this week as we get closer to final designs (Jon K.)`}</li>
      <li parentName="ul">{`Jon K. and Lucas S. both spoke last week at Config, Figma’s first design conference. We’ll send out videos when they become available.`}</li>
    </ul>
    <h2>{`📖 Documentation`}</h2>
    <ul>
      <li parentName="ul">{`The technical work to enable email documentation is in place while initial component build-out and testing continues. (Daniel O., Tom G.)`}</li>
      <li parentName="ul">{`Work continues on the Thumbprint component adoption tracking project. (Daniel O.)`}</li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      